import React, {useState} from 'react';
import Portal from "../../../utils/Portal";
import VerifyPhoneNumber from "../../Layouts/VerifyUser/VerifyPhoneNumber";
import useAxiosIntercept from "../../../hooks/useAxiosIntercept";

function AddEmployee(prop) {
    const [name, setName] = useState('');
    const [designation, setDesignation] = useState();
    const [emailID, setEmailID] = useState('');
    const [showDrop, setShowDrop] = useState(false);
    const [optVerfied, setOptVerfied] = useState(false);
    const [roleValue, setRoleValue] = useState('');
    const [message, setMessage] = useState('');
    const [nameMessage, setNameMessage] = useState('');
    const [emailMessage, setEmailMessage] = useState('');
    const [phoneMessage, setPhoneMessage] = useState('');
    const [designationMessage, setDesigationMessage] = useState('');
    const [roleMessage, setRoleMessage] = useState('');
    const [showAddedPop,setShowAddedPop] = useState(false);

    const [phone, setPhone] = useState('');
    const axiosPrivate = useAxiosIntercept();

    const validateEmail = () => {
        setEmailMessage("");
        let input = emailID;
        var validRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (input.match(validRegex) || input == "") {
            return true;
        } else {
            setEmailMessage("Email not Valid");
            setTimeout(()=>{
                setEmailMessage("");
            },3000)
            // document.form1.text1.focus();
            return false;
        }
    }

    let opt = (value) => {
        setOptVerfied(value);
    }
    let phoneNumber = (number) => {
        setPhone(number);
    }

    let capitalizeName = (name) =>{
        const fullName = name;
        const names = fullName.split(" ");
        const capitalizedNames = names.map(name => name.charAt(0).toUpperCase() + name.slice(1));
        const formattedName = capitalizedNames.join(" ");
        return formattedName;
    }

    let addEmp = async () => {
        try{
            setMessage("");

            let payload = {};
            if(phone)
            payload.phone = phone;
            if(name){
                payload.name = capitalizeName(name);
            }
            payload.user_type = "P";
            if(roleValue){
                payload.role = roleValue.toLowerCase();
            }
            if(designation)
            payload.designation = designation;
            if(emailID)
            payload.email = emailID;

            const res = await axiosPrivate.post( process.env.REACT_APP_ADMIN_OPERATIONS_CREATE_USER_URL, payload);
            if(res?.status == 200){
                if(res?.data?.status == 200){
                    if(res?.data?.response?.data?.user_id){
                        setShowAddedPop(true);
                    }
                }
                else{
                    if(res?.data?.response?.errors){
                        setMessage(res?.data?.response?.errors[0].message);
                        if(res?.data?.response?.errors[0].code){
                            setMessage(res?.data?.response?.errors[0].message+", Contact Admin");
                        }
                        setTimeout(()=>{
                            setMessage("");
                        },3000)
                    }
                }
            }
            else{
                console.log(res?.message);
            }
        }
        catch(err){
            console.log(err);
        }
    }
    const onSubmit = (e) => {
        e.preventDefault();
        setEmailMessage('');
        setNameMessage('');
        setPhoneMessage('');
        setDesigationMessage("")
        setRoleMessage("");
        setMessage("");

        if(name == null || name ==" " || name == ""){
            setNameMessage("Enter Name");
            setTimeout(()=>{
                setNameMessage("");
            },3000)
            setName("");
        }
        else if(emailID == '' ){
            setEmailMessage("Enter Email");
            setTimeout(()=>{
                setEmailMessage("");
            },3000)
        }
        else if(!validateEmail()){
        }
        else if(!optVerfied){
            setMessage('');
            setMessage("verify phone number")
            setTimeout(()=>{
                setMessage("");
            },3000)
        }
        else if(designation == null || designation == ""){
            setDesigationMessage("Enter Designation");
            setTimeout(()=>{
                setDesigationMessage("");
            },3000)
        }
        else if(roleValue == null || roleValue == ""){
            setRoleMessage("Select Role");
            setTimeout(()=>{
                setRoleMessage("");
            },3000)
        }


        //for removing space from start of name
        if(/^\s/.test(name)){
            setName(prevState => prevState.slice(1));
        }

        else if(name && name!=" " && optVerfied && validateEmail() && roleValue!="" && designation!="" ){
            addEmp();
        }
    }

    function handleDesignationChange(event) {
        const regex = /^[a-zA-Z0-9\s-]*$/;
        const newValue = event.target.value;
        if (regex.test(newValue)) {
            setDesignation(newValue);
        }
    }

    return (
        <Portal>
                {showAddedPop ?
                    <div id="myModal" className="popup_box open">
                        <div className="model_box">
                            <div
                                className="model_box_child prd_ns"
                                id="customerAdded"
                                style={{ width: "470px" }}
                            >
                                {/*<div className="ap_heading">*/}
                                {/*    <h4>*/}
                                {/*        Assign a promo{" "}*/}
                                {/*        <span className="material-symbols-rounded black close_model">*/}
                                {/*            close*/}
                                {/*        </span>*/}
                                {/*    </h4>*/}
                                {/*</div>*/}
                                <div className="contentSection customerAdded">
                                    <section>
                                        <span className="material-symbols-rounded fill success">check_circle</span>
                                        <p className="mt-24">
                                            Employee Added Successfully
                                        </p>
                                    </section>
                                    <div className="actionButtons mt-24">
                                <span>
                                    <a href="javascript:void(0);" className="btn prim" onClick={prop.close}>
                                      Ok, thanks
                                    </a>
                                </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    :


                    <div id="myModal" className="popup_box open">
                    <div className="model_box">
                        <div
                            className="model_box_child prd_ns"
                            id="prd_ns"
                            style={{ maxWidth: 570 }}
                        >
                            <div className="ap_heading">
                                <h4>
                                    Add new employee{" "}
                                    <span className="material-symbols-rounded black close_model" onClick={()=>prop.close(false)}>
                                        close
                                    </span>
                                </h4>
                            </div>
                            <div className="contentSection">
                                <section className="b_section dForm empFormPop">
                                    <div className="fieldGroup mt-0">
                                        <label>Employee name</label>
                                        <span>
                                            <input
                                                type="text"
                                                placeholder="Enter full name"
                                                required
                                                onChange={(e) => {setName(e.target.value.replace(/[^A-Za-z]+$/ig  , " "))}}
                                                value={name}
                                                />
                                        </span>
                                        {nameMessage!="" &&
                                            <div>
                                                    <span className="error">
                                                    <span className="material-symbols-rounded error mt-xs fill">
                                                        info
                                                    </span>
                                                        {nameMessage}
                                                    </span>
                                            </div>
                                        }
                                    </div>

                                    <div className="fieldGroup mt-0">
                                        <label>Employee designation</label>
                                        <span>
                                            <input
                                                type="text"
                                                placeholder="Enter designation"
                                                onChange={handleDesignationChange}
                                                value={designation}
                                            />
                                        </span>
                                        {designationMessage!="" &&
                                            <div>
                                                    <span className="error">
                                                    <span className="material-symbols-rounded error mt-xs fill">
                                                        info
                                                    </span>
                                                        {designationMessage}
                                                    </span>
                                            </div>
                                        }
                                    </div>
                                    <div className="fieldGroup">
                                        <label>Official email ID</label>
                                        <span>
                                            <input
                                                onChange={e=>setEmailID(e.target.value)}
                                                type="text"
                                                required
                                                placeholder="Enter Official email ID"
                                                value={emailID}
                                            />
                                        </span>
                                        {emailMessage!="" &&
                                            <div>
                                                    <span className="error">
                                                    <span className="material-symbols-rounded error mt-xs fill">
                                                        info
                                                    </span>
                                                        {emailMessage}
                                                    </span>
                                            </div>
                                        }
                                    </div>
                                    <div className="fieldGroup">
                                        <label>Select role</label>
                                        <div className="multiOption">
                                            <div className={showDrop ? "selectBox fullW open" : "selectBox fullW"} onClick={()=>{setShowDrop(prev => !prev)}}>
                                                {roleValue == '' ? <p>
                                                    Select Employee Role{" "}
                                                    <i className="material-symbols-rounded grey">expand_more</i>
                                                </p> :
                                                    (roleValue == "admin" ?
                                                        <p>
                                                            Admin
                                                            <i className="material-symbols-rounded grey">expand_more</i>
                                                        </p>
                                                            :
                                                            <p>
                                                                Super Admin
                                                                <i className="material-symbols-rounded grey">expand_more</i>
                                                            </p>
                                                    )
                                                }
                                                <div className="selectDrop">
                                                    <ul className="dropMenu">
                                                        <li className="selected" onClick={(e)=>{e.stopPropagation(); setShowDrop(prevState => !prevState); setRoleValue("admin")}}>
                                                            <a href="#" onClick={e => e.preventDefault()}>
                                                                Admin
                                                                {roleValue == "admin" && <i className="material-symbols-rounded">done</i>}
                                                            </a>
                                                        </li>
                                                        <li onClick={(e)=>{e.stopPropagation(); setShowDrop(prevState => !prevState); setRoleValue("super_admin")}}>
                                                            <a href="#" onClick={e=> e.preventDefault()}>
                                                                Super Admin
                                                                {roleValue == "super_admin" && <i className="material-symbols-rounded">done</i>}
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        {roleMessage!="" &&
                                            <div>
                                                    <span className="error">
                                                    <span className="material-symbols-rounded error mt-xs fill">
                                                        info
                                                    </span>
                                                        {roleMessage}
                                                    </span>
                                            </div>
                                        }
                                    </div>

                                    <VerifyPhoneNumber message = {(value)=>{setMessage(value); setTimeout(()=>{setMessage("");
                                    },3000)}} isoptValid={optVerfied} opt={(value)=>{opt(value)}} phone={(value)=>{phoneNumber(value)}}/>

                                </section>
                                {message!="" &&
                                    <div>
                                        <span className="error">
                                            <span className="material-symbols-rounded error mt-xs fill">
                                                info
                                            </span>
                                            {message}
                                        </span>
                                    </div>
                                }


                                <div className="actionButtons mt-8">
                                    <span onClick={onSubmit}>
                                        <a href="" className="btn prim" >
                                          Add employee
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}

        </Portal>

    );
}

export default AddEmployee;